import { __awaiter } from "tslib";
import { DataCollectionEventNames } from './plugins/datacollection';
import { EventServiceErrorType } from './plugins/eventservice';
import { AuthPluginErrorCode } from './plugins/auth';
export class FacadeRegistry {
    static adaptJWeb(jWeb) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('FacadeRegistry::adaptJWeb');
            FacadeRegistry.facades.forEach((adaptFunction) => {
                adaptFunction(jWeb);
            });
            return jWeb;
        });
    }
    static createEventSubscriber(jWeb) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('FacadeRegistry::createEventSubscriber');
            if (jWeb.Plugins.EventService) {
                const createSubscriberOptions = {
                    allowEventingFallback: true
                };
                try {
                    const subscriber = yield jWeb.Plugins.EventService.createSubscriber(createSubscriberOptions);
                    if (FacadeRegistry.isSubscriber(subscriber)) {
                        return subscriber;
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            return null;
        });
    }
    static isSubscriber(result) {
        return result.subscribe !== undefined;
    }
    static isLegacyDataCollectionPlugin(plugin) {
        return plugin.refreshCollectionProfile !== undefined
            && plugin.sendUiEvent !== undefined;
    }
    static addEventUnsubscriber(eventSubscriber) {
        console.log('FacadeRegistry::addEventUnsubscriber: %o', eventSubscriber);
        const globalThis = this.getGlobalThis();
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('beforeunload', () => {
            console.log('FacadeRegistry::beforeunload');
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('visibilitychange', () => {
            console.log('FacadeRegistry::visibilitychange: %s', document.visibilityState);
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('pagehide', (event) => {
            console.log('FacadeRegistry::pagehide: %s', event.persisted ? 'persisted' : 'not persisted');
            if (!event.persisted) {
                eventSubscriber.unsubscribe();
            }
        });
        globalThis === null || globalThis === void 0 ? void 0 : globalThis.addEventListener('pageshow', (event) => {
            console.log('FacadeRegistry::pageshow: %s', event.persisted ? 'persisted' : 'not persisted');
        });
    }
    static eventingFallbackNotAllowedError() {
        console.warn('Eventing Fallback was not allowed.');
        const error = {
            errorType: EventServiceErrorType.eventingFallbackNotAllowed,
            reason: 'Eventing Fallback was not allowed.'
        };
        return error;
    }
    static subscriberIdNotSupportedError() {
        console.warn('Creating a subscriber with a specific ID is not supported.');
        const error = {
            errorType: EventServiceErrorType.subscriberIdNotSupported,
            reason: 'Creating a subscriber with a specific ID is not supported.'
        };
        return error;
    }
    static getCreatePublisherFunction(eventingPlugin) {
        console.log('FacadeRegistry::getCreatePublisherFunction');
        return (_publisherId, createPublisherOptions) => __awaiter(this, void 0, void 0, function* () {
            if (!createPublisherOptions || !createPublisherOptions.allowEventingFallback) {
                return FacadeRegistry.eventingFallbackNotAllowedError();
            }
            const publisher = {
                publish: (eventName, eventData) => __awaiter(this, void 0, void 0, function* () {
                    eventingPlugin.dispatchEvent({
                        name: eventName,
                        data: eventData
                    });
                }),
                destroy: () => __awaiter(this, void 0, void 0, function* () { })
            };
            return publisher;
        });
    }
    static isMatchingEventHandle(eventingHandle, eventName, publisherId) {
        return (eventName &&
            publisherId &&
            eventingHandle.eventName === eventName &&
            eventingHandle.publisherId === publisherId) ||
            (eventName &&
                (publisherId === undefined || publisherId === null) &&
                eventingHandle.eventName === eventName) ||
            (publisherId &&
                (eventName === undefined || eventName === null) &&
                eventingHandle.publisherId === publisherId) ||
            (!eventName && !publisherId);
    }
    static getCreateSubscriberFunction(eventingPlugin) {
        console.log('FacadeRegistry::getCreateSubscriberFunction');
        return (createSubscriberOptions) => __awaiter(this, void 0, void 0, function* () {
            if (!createSubscriberOptions || !createSubscriberOptions.allowEventingFallback) {
                return FacadeRegistry.eventingFallbackNotAllowedError();
            }
            if (createSubscriberOptions.subscriberId) {
                return FacadeRegistry.subscriberIdNotSupportedError();
            }
            let eventingHandles = new Array();
            const error = this.getPersistentUnsupportedError('Using Eventing plugin fallback facade subscriber');
            const subscriber = {
                subscribe: (options, eventHandler) => __awaiter(this, void 0, void 0, function* () {
                    const eventHandlerWrapper = (data, name) => {
                        const info = {
                            subscriber: null,
                            publisherId: options.publisherId,
                            eventName: name,
                            eventData: data
                        };
                        eventHandler(info);
                    };
                    const eventingHandle = eventingPlugin.addListener(options.eventName, eventHandlerWrapper);
                    let isHandleActive = true;
                    const subscriptionHandle = {
                        unsubscribe: () => __awaiter(this, void 0, void 0, function* () {
                            eventingHandle.remove();
                            isHandleActive = false;
                        }),
                        isActive: isHandleActive
                    };
                    eventingHandles.push({
                        eventName: options.eventName,
                        publisherId: options.publisherId,
                        handle: eventingHandle
                    });
                    return subscriptionHandle;
                }),
                unsubscribe: (eventName, publisherId) => __awaiter(this, void 0, void 0, function* () {
                    eventingHandles = eventingHandles.filter((eventingHandle) => {
                        if (FacadeRegistry.isMatchingEventHandle(eventingHandle, eventName, publisherId)) {
                            eventingHandle.handle.remove();
                            return false;
                        }
                        return true;
                    });
                }),
                pauseEvents: () => Promise.resolve(error),
                resumeEvents: () => Promise.resolve(error),
            };
            return subscriber;
        });
    }
    static authPluginNotSupportingInterfaceVersions(plugin) {
        return !(plugin.getSupportedInterfaceVersion);
    }
}
FacadeRegistry.getGlobalThis = () => {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    return null;
};
FacadeRegistry.getPersistentUnsupportedError = (reason) => ({
    errorType: EventServiceErrorType.persistentSubscribersNotSupported,
    reason
});
FacadeRegistry.subscriberNotPersistent = {
    errorType: EventServiceErrorType.subscriberNotPersistent,
    reason: 'Subscriber was created without persistent option set'
};
FacadeRegistry.authFallbackFacade = (jWeb) => __awaiter(void 0, void 0, void 0, function* () {
    if (!jWeb.isPluginAvailable('Auth')) {
        // Cannot adapt Auth if Auth is not available
        return;
    }
    const authPlugin = jWeb.Plugins.Auth;
    if (FacadeRegistry.authPluginNotSupportingInterfaceVersions(authPlugin)) {
        const authFacade = {
            isLoggedIn: authPlugin.isLoggedIn,
            logout: authPlugin.logout,
            addListener: authPlugin.addListener,
            getToken: (options) => {
                if (options) {
                    if (options.tokenProviderOptions.tokenType === 'device') {
                        console.warn('Auth Fallback was not allowed.');
                        const error = {
                            error: {
                                code: AuthPluginErrorCode.invalidOption,
                                reason: 'Legacy plugin dose not support get device token'
                            }
                        };
                        return Promise.resolve(error);
                    }
                    else {
                        const accountProviderOptions = {
                            allowNetworkAccess: options.tokenProviderOptions.allowNetworkAccess,
                            allowUserInteraction: options.tokenProviderOptions.allowUserInteraction,
                            showAccountCreationLink: options.tokenProviderOptions.showAccountCreationLink,
                            skipTokenRefresh: options.tokenProviderOptions.skipTokenRefresh,
                            requireFreshToken: options.tokenProviderOptions.requireFreshToken,
                            userInteractionEntryPoint: options.tokenProviderOptions.userInteractionEntryPoint
                        };
                        const getTokenOptions = { accountProviderOptions };
                        return authPlugin.getToken(getTokenOptions);
                    }
                }
                else {
                    return authPlugin.getToken();
                }
            }
        };
        jWeb.Plugins.Auth = authFacade;
    }
});
// This facade handles old auth implementations that use plugin listeners to broadcast login state changes and
// transforms those broadcasts into published events using the Event Service.
FacadeRegistry.authLoginStateListenerFacade = (jWeb) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!jWeb.isPluginAvailable('Auth') || !jWeb.isPluginAvailable('EventService')) {
        return;
    }
    const authPlugin = (_a = jWeb.Plugins) === null || _a === void 0 ? void 0 : _a.Auth;
    const eventServicePlugin = (_b = jWeb.Plugins) === null || _b === void 0 ? void 0 : _b.EventService;
    const publisherId = "com.hp.jarvis.auth.event.publisher";
    const eventName = "com.hp.jarvis.auth.event.login.change";
    const legacyEventName = "LoginChanged";
    const isEventServiceError = (result) => {
        return result.errorType !== undefined;
    };
    const addTransformer = () => {
        eventServicePlugin === null || eventServicePlugin === void 0 ? void 0 : eventServicePlugin.createPublisher(publisherId).then((result) => {
            if (isEventServiceError(result)) {
                console.error("FacadeRegistry::authLegacyListenerFacade: Create publisher: %o", result);
                return;
            }
            authPlugin === null || authPlugin === void 0 ? void 0 : authPlugin.addListener(legacyEventName, (loginState) => {
                if (loginState.isLoggedIn && loginState.account === undefined) {
                    console.error("FacadeRegistry::authLegacyListenerFacade: Invalid 'LoginState': %o", loginState);
                    return;
                }
                const eventData = {
                    currentAccount: loginState.isLoggedIn ? loginState.account : null,
                    previousAccount: undefined,
                };
                result
                    .publish(eventName, eventData)
                    .catch((error) => console.error("FacadeRegistry::authLegacyListenerFacade: Republish event: %o", error));
            });
        });
    };
    if ((authPlugin === null || authPlugin === void 0 ? void 0 : authPlugin.getSupportedInterfaceVersion) === undefined) {
        addTransformer();
        return;
    }
    authPlugin === null || authPlugin === void 0 ? void 0 : authPlugin.getSupportedInterfaceVersion().then((version) => {
        if (version.major < 1 || (version.major === 1 && version.minor < 8)) {
            addTransformer();
        }
    });
});
// Facade that facilitates Eventing fallback for missing EventService
FacadeRegistry.eventingFallbackFacade = (jWeb) => {
    if (!jWeb.isPluginAvailable('Eventing') || jWeb.isPluginAvailable('EventService')) {
        // Cannot adapt EventService if Eventing is not available
        // Do not want to adapt EventService if it is available
        return;
    }
    const eventingPlugin = jWeb.Plugins.Eventing;
    // Create 'fake' Event Service
    const eventServiceFacade = {
        addListener: () => null,
        createSubscriber: FacadeRegistry.getCreateSubscriberFunction(eventingPlugin),
        createPublisher: FacadeRegistry.getCreatePublisherFunction(eventingPlugin)
    };
    jWeb.Plugins.EventService = eventServiceFacade;
};
// Facade that adds automatic subscription unsubscribe functionality to each subscriber
FacadeRegistry.subscriptionUnsubscribeFacade = (jWeb) => {
    if (!jWeb.isPluginAvailable('EventService')) {
        // Cannot unsubscribe automatically if EventService is not available
        return;
    }
    const eventServicePlugin = jWeb.Plugins.EventService;
    // Automatically unsubscribe event subscribers during page unloading
    if (eventServicePlugin.createSubscriber) {
        const createSubscriberOriginal = eventServicePlugin.createSubscriber;
        eventServicePlugin.createSubscriber = (options) => __awaiter(void 0, void 0, void 0, function* () {
            const subscriberResult = yield createSubscriberOriginal(options);
            if (FacadeRegistry.isSubscriber(subscriberResult)) {
                FacadeRegistry.addEventUnsubscriber(subscriberResult);
            }
            return subscriberResult;
        });
    }
    jWeb.Plugins.EventService = eventServicePlugin;
};
// Facade to transform legacy data collection calls to latest interface
FacadeRegistry.legacyDataCollectionFacade = (jWeb) => {
    if (!jWeb.isPluginAvailable('DataCollection') || !jWeb.isPluginAvailable('EventService')) {
        // Do not want to adapt DataCollection if it was not injected in the first place
        // Cannot adapt DataCollection if EventService is not available
        return;
    }
    const dataCollectionPlugin = jWeb.Plugins.DataCollection;
    if (!FacadeRegistry.isLegacyDataCollectionPlugin(dataCollectionPlugin)) {
        return;
    }
    // If the native side injects the legacy data collection method..
    dataCollectionPlugin.invalidateCache = dataCollectionPlugin.refreshCollectionProfile;
    if (dataCollectionPlugin.sendUiEvent) {
        FacadeRegistry.createEventSubscriber(jWeb).then((subscriber) => {
            // Handle EventService communicating with app that has old data collection component
            if (subscriber) {
                // Register our listener
                const subscribeOptions = {
                    eventName: DataCollectionEventNames.cdmEvent
                };
                subscriber.subscribe(subscribeOptions, (eventInfo) => {
                    // Check if this is a simpleUi event!
                    try {
                        const dataValveCDMEventData = eventInfo.eventData;
                        dataValveCDMEventData.events.forEach((cdmEventData) => {
                            if (cdmEventData.eventCategory === 'simpleUi') {
                                const simpleUiEvent = (cdmEventData.eventDetail);
                                console.log('FacadeRegistry::legacyDataCollectionFacade: Forwarding Simple UI event to legacy DataCollection plugin: %o', simpleUiEvent);
                                dataCollectionPlugin.sendUiEvent(simpleUiEvent).then(() => {
                                    console.log('FacadeRegistry::legacyDataCollectionFacade: Successfully forwarded Simple UI event to legacy DataCollection plugin');
                                }).catch(error => {
                                    console.error('FacadeRegistry::legacyDataCollectionFacade: Error forwarding Simple UI event to legacy DataCollection plugin: %o', error);
                                });
                            }
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                });
            }
        });
    }
};
// Facade to handle older version of EventService by adding pause/resume subscriber methods that return error
FacadeRegistry.eventPersistenceFacade = (jWeb) => {
    if (!jWeb.isPluginAvailable('EventService')) {
        // Cannot update methods if EventService is not available
        return;
    }
    const eventServicePlugin = jWeb.Plugins.EventService;
    if (eventServicePlugin.createSubscriber) {
        const createSubscriberOriginal = eventServicePlugin.createSubscriber;
        eventServicePlugin.createSubscriber = (options) => __awaiter(void 0, void 0, void 0, function* () {
            const subscriberResult = yield createSubscriberOriginal(options);
            if (FacadeRegistry.isSubscriber(subscriberResult)) {
                const isMissingPersistenceMethods = subscriberResult.pauseEvents === undefined || subscriberResult.resumeEvents === undefined;
                if (isMissingPersistenceMethods) {
                    if (options === null || options === void 0 ? void 0 : options.isPersistent) {
                        return FacadeRegistry.getPersistentUnsupportedError('Host app does not support persistent subscribers in injected EventService plugin');
                    }
                    else {
                        console.log('FacadeRegistry::eventPersistenceFacade: Attaching persistence methods');
                        subscriberResult.pauseEvents = () => Promise.resolve(FacadeRegistry.subscriberNotPersistent);
                        subscriberResult.resumeEvents = () => Promise.resolve(FacadeRegistry.subscriberNotPersistent);
                    }
                }
            }
            return subscriberResult;
        });
    }
    jWeb.Plugins.EventService = eventServicePlugin;
};
// Facade to handle older version of EventService by identifying if user is sending a subscriberId and if so returns an error.
FacadeRegistry.createSubscriberWithIdFacade = (jWeb) => {
    if (!jWeb.isPluginAvailable('EventService')) {
        // Cannot update methods if EventService is not available
        return;
    }
    const eventServicePlugin = jWeb.Plugins.EventService;
    if (eventServicePlugin.createSubscriber) {
        const createSubscriberOriginal = eventServicePlugin.createSubscriber;
        eventServicePlugin.createSubscriber = (options) => __awaiter(void 0, void 0, void 0, function* () {
            const subscriberResult = yield createSubscriberOriginal(options);
            if (FacadeRegistry.isSubscriber(subscriberResult) && (options === null || options === void 0 ? void 0 : options.subscriberId)) {
                const haveTheSameSubscriberId = subscriberResult.subscriberId === options.subscriberId;
                if (!haveTheSameSubscriberId) {
                    return FacadeRegistry.subscriberIdNotSupportedError();
                }
            }
            return subscriberResult;
        });
    }
    jWeb.Plugins.EventService = eventServicePlugin;
};
// Fixed order of facades.
// These facades are applied sequentially
FacadeRegistry.facades = [
    FacadeRegistry.eventingFallbackFacade,
    FacadeRegistry.subscriptionUnsubscribeFacade,
    FacadeRegistry.legacyDataCollectionFacade,
    FacadeRegistry.eventPersistenceFacade,
    FacadeRegistry.createSubscriberWithIdFacade,
    FacadeRegistry.authFallbackFacade,
    FacadeRegistry.authLoginStateListenerFacade
];
//# sourceMappingURL=facade-registry.js.map